<template>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Visit Start time
      </th>
      <!-- <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Gender
      </th> -->

      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.email == null ? "" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p v-if="user.ipd != null" class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            formatDateTime_int(user.created_at)
          }}</soft-badge>
        </td>
        <!-- <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{{
            user.gender == null
              ? "--"
              : user.gender == 1
              ? "Male"
              : user.gender == 2
              ? "Female"
              : "Other"
          }}</span>
        </td> -->
        <td class="align-middle">
          <button
            @click="showPatientDetailsmodel(user.patient_id)"
            style="color: white; background-color: green"
            class="btn-xs font-weight-bold text-xs"
          >
            View patient</button
          >.
          <a
            :href="'/visit_summary/' + user.id"
            style="
              border: 1px solid black;
              padding: 4px;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
            >Visit Summary</a
          >
        </td>
      </tr>
    </template>
  </BaseLayout>
  <ShowPatientModal
    v-if="showModalPatientDetailsModel"
    @close="handleClosePatientDetailsmodel"
    :patient_id="insearch_patient"
  />
</template>

<script>
import ShowPatientModal from "../../Patients/components/patient_details.vue";
import BaseLayout from "../../Patients/components/table_page_layout.vue";
// import formatDateTime from "../../timezone/utc_local_time.js";
import formatDateTime from "../../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      // visit_id: this.$route.params.storeLocation,
      showModalPatientDetailsModel: false,
      insearch_patient: "",
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "get_all_past_visits_search",
      mainUrl: "get_all_past_visits",
    };
  },
  components: {
    BaseLayout,
    ShowPatientModal,
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },

    handleClosePatientDetailsmodel() {
      this.showModalPatientDetailsModel = false;
    },

    showPatientDetailsmodel(patient) {
      this.insearch_patient = patient;
      this.showModalPatientDetailsModel = true;
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
